export * from './src/locale/index';